import { render } from "./Americano.vue?vue&type=template&id=0dd99ac6"
import script from "./Americano.vue?vue&type=script&lang=ts"
export * from "./Americano.vue?vue&type=script&lang=ts"
script.render = render

export default script